import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { QuickSearchLayerCheckStateService } from '@lassi/webapp-shared';

@Component({
  selector: 'lassi-quick-search-layer-check',
  imports: [MatButtonModule],
  template: `
    @if (layerCheckState.missingLayers().length > 0) {
      <div class="layer-check">
        <p class="message mat-label-medium">
          If you cannot see the results on the map, the relevant layers may not
          be turned on.
        </p>
        <button mat-button color="primary" (click)="enableLayers()">
          Turn on required layers
        </button>
      </div>
    }
  `,
  styles: `
    :host {
      display: contents;
    }

    .layer-check {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 0.5rem 0 0 1rem;
      background: white;
      border-top: 1px solid #e6e6e6;
      margin: 0;
      max-width: var(--layer-check-width, 100%);
      width: 100%;
      box-sizing: border-box;
    }

    .message {
      margin: 0;
      font-size: 0.875rem;
      line-height: 1.25;
    }

    button {
      padding-left: 0;
      min-width: auto;
      height: 32px;
      align-self: flex-start;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--layer-check-width.px]': 'width()',
  },
})
export class QuickSearchLayerCheckComponent {
  readonly layerCheckState = inject(QuickSearchLayerCheckStateService);
  readonly width = input<number>();

  async enableLayers() {
    await this.layerCheckState.enableLayers();
  }
}
